import { temperatureType } from 'store/typesActions/types';

const initialState = {
	temperatureApi: {},
	isLoading: false,
	error: false,
	message: ''
};

export default function temperatureReducer(state = initialState, action) {
	const { errors } = action?.payload || { errors: {} };

	switch (action.type) {
		case temperatureType.TEMPERATURE_REC:
			return {
				...state,
				isLoading: true,
				error: false,
				message: 'Buscando dados do desmatamento'
			};

		case temperatureType.TEMPERATURE_REC_SUCCESS:
			return {
				temperatureApi: action.payload,
				isLoading: false,
				error: false,
				message: ''
			};

		case temperatureType.TEMPERATURE_REC_ERROR:
			return {
				...state,
				temperatureApi: {},
				isLoading: false,
				error: true,
				message: 'Erro ao buscar por dados, tente novamente mais tarde'
			};
		default:
			return state;
	}
}
